import { RefObject, useEffect, useRef } from 'react'

export const ATTR_NAME_RESTRICT_CLICK_OUTSIDE = 'data-restrict-click-outside'
export const ATTR_RESTRICT_CLICK_OUTSIDE = {
  [ATTR_NAME_RESTRICT_CLICK_OUTSIDE]: true,
}

export function useOnClickOutside<T extends HTMLElement>(
  node: RefObject<T | undefined>,
  handler: undefined | (() => void),
  ignoredNodes: Array<RefObject<T | undefined>> = []
) {
  const handlerRef = useRef<undefined | (() => void)>(handler)

  useEffect(() => {
    handlerRef.current = handler
  }, [handler])

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const nodeClicked = node.current?.contains(e.target as Node)
      const ignoredNodeClicked = ignoredNodes.reduce(
        (reducer, val) => reducer || !!val.current?.contains(e.target as Node),
        false
      )

      if ((nodeClicked || ignoredNodeClicked) ?? false) {
        return
      }

      const isIgnoredByAttribute = !!(e as any).path?.some((item: Element) => {
        return item.hasAttribute ? item.hasAttribute(ATTR_NAME_RESTRICT_CLICK_OUTSIDE) : false
      })

      if (isIgnoredByAttribute) {
        return
      }

      if (handlerRef.current) handlerRef.current()
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [node, ignoredNodes])
}
